import { makeObservable, action } from 'mobx';
import { Tool, type ToolContext } from './base/Tool';
import type { IconElement, Element as CanvasElement } from '@/types';

export class IconTool extends Tool {
  constructor() {
    super('icon', 'Icon');
    makeObservable(this, {
      onStart: action,
      onMove: action,
      onEnd: action,
    });
  }

  onStart(_context: ToolContext): CanvasElement | null {
    // IconTool doesn't create elements on start
    // The palette is automatically shown when this tool is active
    return null;
  }

  onMove(_context: ToolContext): CanvasElement | null {
    // No preview for icon tool since it uses drag and drop
    return null;
  }

  onEnd(_context: ToolContext): CanvasElement | null {
    // No direct element creation, handled by drag and drop
    return null;
  }

  getCursor(): string {
    return 'default';
  }

  /**
   * Create an icon element from drag and drop data
   */
  createIconElement(
    iconName: string,
    x: number,
    y: number,
    width: number = 48,
    height: number = 48,
    style: any
  ): IconElement {
    return {
      id: this.generatePreviewId(),
      type: 'icon',
      x,
      y,
      width,
      height,
      iconName,
      style: {
        ...style,
        strokeWidth: 1.5, // Use a thinner stroke for better icon appearance
        fillColor: 'transparent', // Icons never have background colors
        fillPattern: 'solid' as const, // Icons don't use fill patterns
      },
      isSelected: false,
      zIndex: 0,
      createdAt: Date.now(),
      updatedAt: Date.now(),
    };
  }
}
